import { StateCreator } from 'zustand/vanilla';

import handleDropdownClose from '@/state/middlewares/events-handler/handle-dropdown-close';
import handleDropdownOpen from '@/state/middlewares/events-handler/handle-dropdown-open';
import handleLanguageSelectorDropdownOpen from '@/state/middlewares/events-handler/handle-language-selector-dropdown-open';
import handleRetailersDropdownClose from '@/state/middlewares/events-handler/handle-retailers-dropdown-close';
import handleRetailersDropdownOpen from '@/state/middlewares/events-handler/handle-retailers-dropdown-open';
import handleVehiclesDropdownId from '@/state/middlewares/events-handler/handle-vehicles-dropdown-open';
import { IStore } from '@/state/slices/typings';

class EventHandlerClass {
	private static _instance: EventHandlerClass;

	public static get instance(): EventHandlerClass {
		if (!EventHandlerClass._instance) {
			EventHandlerClass._instance = new EventHandlerClass();
		}

		return EventHandlerClass._instance;
	}

	public middleware<T extends IStore>(
		config: StateCreator<T>,
	): StateCreator<T> {
		return (set, get, api) =>
			config(
				// @ts-expect-error - It looks difficult to type this
				(args: any, replace: false | undefined) => {
					const prevState = get();
					set(args, replace);
					const nextState = get();

					[
						handleDropdownOpen,
						handleDropdownClose,
						handleVehiclesDropdownId,
						handleLanguageSelectorDropdownOpen,
						handleRetailersDropdownClose,
						handleRetailersDropdownOpen,
					].forEach((handler) => handler(prevState, nextState));
				},
				get,
				api,
			);
	}
}

const EventHandler = EventHandlerClass.instance;

export default EventHandler;
